import React from 'react';
import TabFactPanels from '../TabFactPanels';

import { useParams } from 'react-router-dom';

import {
  useQueryFactsPanel,
  useQuerySupplementFactsPanel,
  useQueryDrugFactsPanel,
  useQueryPetFoodPanel,
} from './useQueryFactsPanel';
import { useGetProductOverlay } from 'hooks/product';
import { addOriginData } from './utils';

const MultipleFactsPanel = () => {
  const { id } = useParams();

  const { originalProductId } = useGetProductOverlay({ productId: id });

  const { listFactsPanel, isLoading: factsPanelLoading } = useQueryFactsPanel({
    id,
  });
  const { listSupplementFactsPanel, isLoading: supplementLoading } =
    useQuerySupplementFactsPanel({
      id,
    });

  const { listFactsPanel: originFactPanel } = useQueryFactsPanel({
    id: originalProductId,
  });

  const { listSupplementFactsPanel: originSupplement } =
    useQuerySupplementFactsPanel({
      id: originalProductId,
    });

  const { listDrugFactsPanel, isLoading: drugLoading } = useQueryDrugFactsPanel(
    {
      id,
    }
  );

  const { listDrugFactsPanel: originDrugPanel } = useQueryDrugFactsPanel({
    id: originalProductId,
  });

  const { listPetFoodPanel, isLoading: petFoodLoading } = useQueryPetFoodPanel({
    id,
  });

  const { listPetFoodPanel: originPetPanel } = useQueryPetFoodPanel({
    id: originalProductId,
  });

  const addOriginFactPanel = addOriginData({
    originValue: originFactPanel,
    currentValue: listFactsPanel,
  });

  const addOriginSupplement = addOriginData({
    originValue: originSupplement,
    currentValue: listSupplementFactsPanel,
  });

  const addOriginDrug = addOriginData({
    originValue: originDrugPanel,
    currentValue: listDrugFactsPanel,
  });

  const addOriginPet = addOriginData({
    originValue: originPetPanel,
    currentValue: listPetFoodPanel,
  });

  const totalFactsPanels = [
    ...addOriginFactPanel,
    ...addOriginSupplement,
    ...addOriginDrug,
    ...addOriginPet,
  ];

  const loading =
    factsPanelLoading || supplementLoading || drugLoading || petFoodLoading;

  return (
    <TabFactPanels loading={loading} totalFactsPanels={totalFactsPanels} />
  );
};

export default MultipleFactsPanel;
